import React from 'react';
import { markTabStale } from '@/shared/utils/staleTab';

/**
 * Wraps a `React.lazy` component. When its code cannot load, usually because an upgrade removed the
 * file this tab asks for, it renders nothing and marks the tab stale, so the next navigation reloads
 * the page instead of the whole app unmounting.
 */
export default class LazyImportBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { failed: false };
    }

    static getDerivedStateFromError() {
        return { failed: true };
    }

    componentDidCatch() {
        markTabStale();
    }

    render() {
        return this.state.failed ? null : this.props.children;
    }
}
